import React, { createContext, useContext, useState, useMemo, useCallback } from 'react'
import { node } from 'prop-types'

const FeedBadgeContext = createContext()

export function useFeedBadge() {
  const context = useContext(FeedBadgeContext)
  if (!context) {
    throw new Error('useFeedBadge must be used within a FeedBadgeProvider')
  }
  return context
}

export function FeedBadgeProvider({ children }) {
  const [badgeCount, setBadgeCount] = useState(0)
  const [feedIconRef, setFeedIconRef] = useState(null)

  const incrementBadgeCount = useCallback(() => {
    setBadgeCount((prev) => prev + 1)
  }, [])

  const resetBadgeCount = useCallback(() => {
    setBadgeCount(0)
  }, [])

  const value = useMemo(
    () => ({ badgeCount, incrementBadgeCount, resetBadgeCount, feedIconRef, setFeedIconRef }),
    [badgeCount, incrementBadgeCount, resetBadgeCount, feedIconRef]
  )

  return <FeedBadgeContext.Provider value={value}>{children}</FeedBadgeContext.Provider>
}

FeedBadgeProvider.propTypes = {
  children: node.isRequired,
}
